<template>
  <div class="members">
    <router-view />
    <SearchBar @search="handleSearchMember" :searchWord="searchWord" />
    <div class="content--main" v-if="members">
      <div class="row" v-if="members.length === 0">
        <div class="col-6 length-0">
          <span>No results found</span>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-4 member--list-wrapper">
          <div class="member--list" v-scroll="onScroll">
            <div v-for="(member, i) of members" :key="i">
              <Widget
                :widgets="member"
                @widgetClick="handleWidgetClick(i, member)"
                :class="i === activeIndex ? 'active' : ''"
                @mouseover.native="hoveredWidget.push(member.id)"
                @mouseleave.native="hoveredWidget.splice(1)"
                :style="{
                  backgroundColor: hoveredWidget.includes(member.id)
                    ? secondary
                    : '#fafafa',
                  transition: 'background-color 0.2s ease'
                }"
              >
                <div class="widget--avatar">
                  <img
                    v-if="member.avatar"
                    :src="member.avatar"
                    alt="user avatxar"
                  />
                  <span v-else>{{ member.firstName[0] }}</span>
                </div>
                <div class="widget--info">
                  <p class="mb-0">
                    {{ member.firstName }} {{ member.lastName }}
                  </p>
                  <p class="muted mb-0">
                    {{
                      member.Companies && member.Companies.length > 0
                        ? member.Companies[0].name
                        : ""
                    }}
                    -
                    {{
                      member.Roles && member.Roles.length > 0
                        ? member.Roles[0].name
                        : ""
                    }}
                  </p>
                </div>
              </Widget>
            </div>
          </div>
        </div>
        <div class="col-8 member--profile-wrapper" v-if="singleMember">
          <div class="member--profile">
            <WidgetDetails
              title="Profile"
              :widgetOptions="widgetOptions"
              @deleteMember="handleDeleteMemberClick"
              @editMemberDetails="handleEditMemberClick"
              @changePassword="handleChangePassword"
            >
              <div class="d-flex">
                <div v-if="singleMember.avatar" class="widget--avatar">
                  <img :src="singleMember.avatar" alt="user avatar" />
                </div>
                <div v-else class="widget--avatar">
                  <span>{{ singleMember.firstName[0] }}</span>
                </div>
                <div class="widget--details-wrapper">
                  <h4>
                    {{ singleMember.firstName }} {{ singleMember.lastName }}
                  </h4>
                  <p class="-muted">
                    <img
                      src="~@/assets/media/icons/user.svg"
                      alt="member icon"
                    />{{
                      singleMember.Roles && singleMember.Roles.length != 0
                        ? singleMember.Roles[0].name
                        : ""
                    }}
                  </p>
                  <div class="row">
                    <div class="col">
                      <p v-if="singleMember.email">
                        <img
                          src="~@/assets/media/icons/email.svg"
                          alt="email icon"
                        />{{ singleMember.email }}
                      </p>
                      <p v-if="singleMember.mobile">
                        <img
                          src="~@/assets/media/icons/call.svg"
                          alt="phone icon"
                        />{{ singleMember.mobile }}
                      </p>
                    </div>
                    <div class="col">
                      <template
                        v-if="
                          singleMember.Companies &&
                            singleMember.Companies.length > 0
                        "
                      >
                        <p>
                          <img
                            v-if="singleMember.Companies[0].name"
                            src="~@/assets/media/icons/company.svg"
                            alt="email icon"
                          />{{ singleMember.Companies[0].name }}
                        </p>
                        <p>
                          <img
                            v-if="singleMember.Companies[0].mobile"
                            src="~@/assets/media/icons/assignment.svg"
                            alt="phone icon"
                          />{{ singleMember.Companies[0].mobile }}
                        </p>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row align-items-end justify-content-between widget--table-row mx-0"
              >
                <div class="col px-0"><h4>Invoice</h4></div>
                <div class="col px-0 text-right">
                  <ActionButton
                    label="Make a Booking"
                    class="mt-0 d-inline-block w-auto"
                    :theme="{ primary, secondary, event, danger }"
                    @customEvent="
                      $router.push({
                        name: `${$route.matched[0].name}-booking`,
                        params: { id: singleMember.id }
                      })
                    "
                  />
                </div>
              </div>
              <div class="row mx-0" v-if="selectedUserInvoices">
                <div class="col" v-if="selectedUserInvoices.length > 0">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Invoice ID</th>
                        <th>Amount</th>
                        <th>Payment Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template>
                        <tr
                          v-for="order of selectedUserInvoices"
                          :key="order.id"
                        >
                          <td>{{ order.code }}</td>
                          <td
                            v-if="
                              order.code === 'Contract for Private Office' ||
                                order.code === 'Contract for Virtual Office'
                            "
                          >
                            &mdash;
                          </td>
                          <td v-else>
                            <span v-if="order.totalAmount">
                              Php
                              {{
                                order.totalAmount.toLocaleString("en-US", {
                                  minimumFractionDigits: 2
                                })
                              }}
                            </span>
                          </td>
                          <td class="font-weight-bold">
                            <span class="text-warning" v-if="order.cancelledAt">
                              Cancelled
                            </span>
                            <span class="text-success" v-else-if="order.paidAt">
                              &#10003; Paid
                            </span>
                            <span class="text-danger" v-else>
                              Unpaid
                            </span>
                          </td>
                          <td>
                            <span
                              v-if="
                                order.code === 'Contract for Private Office' ||
                                  order.code === 'Contract for Virtual Office'
                              "
                              >&mdash;</span
                            >
                            <router-link
                              v-else
                              :style="{ color: primary }"
                              tag="a"
                              :to="
                                '/' +
                                  mainModule +
                                  '/booking/' +
                                  singleMember.id +
                                  '/invoice/' +
                                  order.id
                              "
                              >View</router-link
                            >
                            <a
                              v-if="!order.paidAt && !order.cancelledAt"
                              @click="handleCancelInvoice(order.id, order.code)"
                              :style="{ color: danger }"
                              class="ml-10 tag-link"
                              >Cancel</a
                            >
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
                <div class="col mt-3 length-0" v-else>
                  <span colspan="4">No orders found</span>
                </div>
              </div>
              <Spinner class="mt-3" v-else :theme="primary" />
            </WidgetDetails>
          </div>
        </div>
      </div>
    </div>
    <Spinner class="mt-3" v-else :theme="primary" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ActionButton from "@/components/ActionButton";
import SearchBar from "@/components/SearchBar";
import Widget from "@/modules/concierge/elements/Widget";
import Spinner from "@/components/Spinner";
import WidgetDetails from "@/modules/concierge/elements/WidgetDetails";
import axios from "@/helpers/axios";
import { dateToday } from "@/helpers/date";
import { socketSender } from "@/helpers/socket";
import {
  bookingCancelEmail,
  bookingCancelEmailToOwner
} from "@/helpers/mailer";

export default {
  name: "ConciergeMembers",
  components: {
    SearchBar,
    Widget,
    WidgetDetails,
    ActionButton,
    Spinner
  },
  data() {
    return {
      apiOptions: {
        mode: "pagination",
        link: null,
        queryParams: "orderBy=lastName:ASC"
      },
      mainModule: this.$route.matched[0].name,
      searchWord: "",
      selectedUserInvoices: null,
      widgetOptions: [
        {
          icon: "edit",
          label: "Edit Details",
          method: "editMemberDetails"
        },
        {
          icon: "edit",
          label: "Change Password",
          method: "changePassword"
        },
        {
          icon: "Deactivate",
          label: "Deactivate",
          method: "deleteMember"
        }
      ],
      hoveredWidget: []
    };
  },
  computed: {
    members() {
      this.handleGetBookings();
      return this.getMembers();
    },
    singleMember() {
      if (this.getMembers()) {
        return this.getMembers()[this.$store.state.concierge.activeIndex];
      }
      return {};
    },
    activeIndex() {
      return this.$store.state.concierge.activeIndex;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  watch: {
    members() {
      if (this.members.length == 1) {
        this.updateSearchWord(
          this.singleMember.firstName + " " + this.singleMember.lastName
        );
      }
    }
  },
  async mounted() {
    if (this.$route.params.member) {
      let row = this.$route.params.member;
      let options = {
        queryParams: "id=" + row.id
      };
      await this.$store.dispatch("fetchUsers", options);
    } else {
      await this.$store.dispatch("fetchUsers", this.apiOptions);
    }
    await this.handleWidgetClick(0, this.members[0]);
  },
  methods: {
    ...mapGetters({
      getMembers: "getMembers"
    }),
    ...mapActions({
      changeActiveTrail: "changeActiveTrail"
    }),
    updateSearchWord(word) {
      this.searchWord = word;
    },
    handleCancelInvoice(id, code) {
      this.$swal({
        title: "Are you sure you want to cancel this order?",
        text: code,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#e15a4e",
        cancelButtonText: "No",
        reverseButtons: true
      }).then(async result => {
        if (result.value) {
          await axios
            .patch("/orders/" + id, {
              cancelledAt: dateToday()
            })
            .then(() => {
              this.handleGetBookings();
            });

          let specRecord = await axios.get(`/orders/${id}`).then(result => {
            return result.status == 200 ? result.data.data : [];
          });
          bookingCancelEmail({
            to: specRecord.User.email,
            displayName: specRecord.User.displayName,
            order: specRecord
          });

          bookingCancelEmailToOwner({
            fullName:
              specRecord.User.firstName + " " + specRecord.User.lastName,
            order: specRecord
          });
        }
      });
    },
    async onScroll(el, position) {
      let divScrollHeight = Math.floor(el.target.scrollHeight);
      let scrollCurrentHeight = Math.floor(
        position.scrollTop + el.target.offsetHeight
      );
      let data = this.$store.state.concierge.userList;
      if (divScrollHeight === scrollCurrentHeight && data.meta.hasNextPage) {
        let options = { link: data.links.next + "&orderBy=lastName:ASC" };
        await this.$store.dispatch("fetchUsers", options);
      }
    },
    handleDeleteMemberClick() {
      if (this.selectedUserInvoices && this.selectedUserInvoices.length > 0) {
        this.$swal({
          title: "Member has bookings. Can't deactivate member.",
          type: "error"
        });
      } else {
        this.$swal({
          title: "Do you want to deactivate this member?",
          type: "warning",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true
        }).then(async result => {
          if (result.value == true) {
            /**
             * SOCKET: Deactivate member
             */
            socketSender(
              "updateLog",
              `${this.$store.getters.getFullUser} deactivated the user ${this.singleMember.firstName} ${this.singleMember.lastName}`
            );

            await this.$store.dispatch("removeMember", this.singleMember.id);
            this.members.splice(this.activeIndex, 1);
          }
        });
      }
    },
    handleChangePassword() {
      let modal =
        this.mainModule == "concierge"
          ? this.mainModule + "-members-add-member"
          : this.mainModule + "-members-page-add-member";
      let name = "change-password";
      let singleRecord = this.singleMember;
      this.$emit("showModal", { modal, name, singleRecord });
    },
    handleEditMemberClick() {
      let modal =
        this.mainModule == "concierge"
          ? this.mainModule + "-members-add-member"
          : this.mainModule + "-members-page-add-member";
      let name = "edit-member";
      let singleRecord = this.singleMember;
      this.$emit("showModal", { modal, name, singleRecord });
    },
    async handleWidgetClick(index, member) {
      const { matched, path } = this.$route;
      const { firstName, lastName, id } = member;
      this.$store.commit("changeActiveIndex", index);
      this.changeActiveTrail([
        { name: "Home", link: matched[0].path },
        { name: "Members", link: path },
        { name: `${firstName} ${lastName}` }
      ]);
      this.hoveredWidget = [];
      this.hoveredWidget.push(id);
    },
    async handleGetBookings() {
      if (this.singleMember && this.singleMember.id) {
        this.selectedUserInvoices = null;
        let orders = await axios
          .get(`/users/${this.singleMember.id}/orders`)
          .then(response => response.data.data.rows);
        this.selectedUserInvoices = orders || null;
      }
    },
    async handleSearchMember(searchTerm) {
      // this.searchWord = searchTerm;
      if (searchTerm != null && searchTerm != "") {
        await this.$store.dispatch("searchUsers", searchTerm);
        await this.$store.commit("changeActiveIndex", 0);
        // await this.handleWidgetClick(0, this.members[0]);
      } else {
        await this.$store.dispatch("fetchUsers", this.apiOptions);
      }
      // await this.handleGetBookings();
    }
  }
};
</script>

<style lang="scss" scoped>
.members {
  padding: 0 15px;
  .content--main {
    height: calc(
      100vh - 274px
    ); /* height of viewport minus the sum of nav.header and <SearchBar/> */
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 20px;
    padding-top: 20px;
    & > .row {
      height: 100%;
      div[class^="col-"] {
        height: 100%;
        overflow: auto;
      }
    }
    .member {
      &--list {
        border-radius: 5px;
        overflow: auto;
        height: 100%;
      }
      &--profile {
        background-color: $gray-50;
        border-radius: 5px;
        max-height: 100%;
        overflow: auto;
        .widget--avatar {
          margin-right: 30px;
          span {
            align-items: center;
            background-color: $brand-primary;
            border-radius: 50%;
            color: $white;
            display: flex;
            font-family: "Gotham";
            font-size: $font-size-xl;
            font-weight: 500;
            height: 110px;
            justify-content: center;
            width: 110px;
          }
          img {
            border-radius: 50%;
            display: block;
            height: 110px;
            object-fit: cover;
            width: 110px;
          }
        }
        .widget--details-wrapper {
          h4 {
            color: $gray-900;
            font-size: $font-size-md;
            font-weight: 500;
            margin-bottom: 10px;
          }
          p {
            align-items: flex-start;
            display: flex;
            font-family: "Gotham Book";
            font-size: $font-size-sm;
            img {
              margin-right: 10px;
              height: 20px;
              width: 20px;
            }
            &.-muted {
              color: $gray-550;
            }
          }
        }
        .widget--table-row {
          border-bottom: 1px solid $gray-250;
          padding: 10px 0;
          h4 {
            color: $gray-900;
            font-size: $font-size-xs;
            font-weight: 500;
          }
        }
        .length-0 {
          span {
            color: $gray-900;
            font-family: "Gotham Book";
            font-size: $font-size-sm;
            text-align: left;
          }
        }
        .table {
          font-size: $font-size-xs;
          thead {
            th {
              color: $gray-900;
              font-weight: 500;
            }
          }
          tbody {
            td {
              color: $gray-900;
              font-family: "Gotham Book";
            }
          }
        }
      }
    }
    .length-0 {
      span {
        color: $gray-900;
        font-family: "Gotham Book";
        font-size: $font-size-sm;
        text-align: left;
      }
    }
  }
}
.tag-link {
  cursor: pointer;
  &:hover {
    text-decoration: underline !important;
  }
}
</style>
